<template>
    <textfield-screen
            :title="$ml.get('setEmailTitle')"
            v-model="text"
            :is-not-valid="isNotValid"
            :is-not-valid-message="isNotValidMessage"
            @next="nextScreen"
            @back="back"
    >
        <template slot="bottomLink">
            <a class="link" @click.stop="nextScreen" v-text="$ml.get('setEmailBottomText')">Не пам'ятаю електронної адреси</a>
        </template>
    </textfield-screen>

</template>

<script>
    import TextfieldScreen from "../../components/layout/textfield-screen";
    export default {
        name: "setEmailPage",
        components: {TextfieldScreen},
        methods: {
            nextScreen: function () {
                this.$router.push({ name: 'RegistrationLastName'});
            },
            startLogin: function () {
                this.$router.push({ name: 'LoginEnterCode'});
            },
            back: function () {
                this.$router.back();
            },
        }
    }
</script>

<style scoped>

</style>